import { connect, type Methods, WindowMessenger } from "penpal";

type Options<TMethods> = {
  window: Window;
  methods: TMethods;
};

export const connectToWindow = <TMethods extends Methods, TExposedMethods extends Methods = Methods>({
  window,
  methods,
}: Options<TExposedMethods>) => {
  const messenger = new WindowMessenger({
    remoteWindow: window,
    // Allow all origins since the iframe is loaded from a trusted source (baseUrl)
    // The security boundary is the checkout_token, not the origin
    allowedOrigins: ["*"],
  });
  return connect<TMethods>({ methods, messenger });
};
